<div class="btn-group switch">
    <a class="btn btn-outline btn-off"
       [class]="{'current': chartType === INTERACTIVE_MODE}"
       (click)="toggleChartType($event)">Off</a>
    <a class="btn btn-outline btn-on"
       [class]="{'current': chartType === PRESENTATION_MODE}"
       (click)="toggleChartType($event)">On</a>
</div>
